import { defineSlotRecipe } from "@chakra-ui/react";
export const tagsInputRecipe = defineSlotRecipe({
    className: "chakra-tags-input",
    slots: ["root", "control", "input", "item", "itemPreview", "itemText", "itemDeleteTrigger", "label"],
    base: {
        control: {
            rounded: "md",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "1",
            cursor: "pointer",
            borderWidth: "1px",
            borderColor: "border",
            bg: "bg",
            paddingStart: "2",
            paddingEnd: "2",
            paddingY: "1",
            minHeight: "34px",
            transitionProperty: "common",
            transitionDuration: "normal",
            _hover: {
                borderColor: "border.emphasized",
            },
            _focusWithin: {
                outline: "2px solid",
                outlineOffset: "0.5px",
                outlineColor: "colorPalette.focusRing/15",
                zIndex: 1,
                borderColor: "colorPalette.focusRing",
                boxShadow: "0 0 0 1px var(--chakra-colors-colorPalette-focusRing)",
            },
        },
        input: {
            outline: "none",
            border: "none",
            bg: "transparent",
            flex: "1 1 60px",
            minWidth: "60px",
            cursor: "pointer",
            _placeholder: {
                color: "fg.muted",
            },
        },
        item: {
            rounded: "sm",
        },
        itemPreview: {
            rounded: "sm",
            bg: "gray.100",
            px: "2",
            py: "0.5",
            fontSize: "xs",
            height: "22px",
            display: "inline-flex",
            alignItems: "center",
            gap: "1",
            cursor: "pointer",
            _hover: {
                bg: "gray.200",
            },
        },
        itemText: {
            fontSize: "xs",
            lineHeight: "1",
        },
        itemDeleteTrigger: {
            cursor: "pointer",
            opacity: 0.6,
            _hover: {
                opacity: 1,
            },
        },
    },
    defaultVariants: {},
});
